import { createAutomationApi } from './automationApi';
import type { Runtime } from './runtime';

export function attachRuntimeAutomation(win: Window, runtime: Runtime): void {
  const { renderer, scene, camera, pipeline, materials, world } = runtime.init;
  win.__AMS1538__ = createAutomationApi(
    renderer,
    scene,
    camera,
    pipeline,
    () => runtime.control.controlState,
    () => world.stats,
    world.stats.buildMs,
    () => materials.renderHeight,
    () => runtime.network?.diagnostics() ?? null,
    () => [...runtime.visitorView.diagnostics(), ...(runtime.network?.visitors() ?? [])],
    () => world.animated.flatMap((actor) => actor.townspeople?.list() ?? []),
    () => runtime.communications.diagnostics(),
    () => runtime.discoveries.diagnostics(),
    () => materials.painted().uniforms['uPainterAmount']?.value as number
  );
}
